import { backend, domain } from 'modules/data';

export const sortNetSuiteCustomFields = <T extends domain.NetSuiteCustomField>(
    customFields: T[],
    companyCustomFields: backend.NetSuiteCompanyCustomField[]
) => {
    return [...customFields].sort((field1, field2) => {
        const fieldReference1 = companyCustomFields.find(
            (companyField) => companyField.NetSuiteField.Field.ScriptId === field1.scriptId
        );

        const fieldReference2 = companyCustomFields.find(
            (companyField) => companyField.NetSuiteField.Field.ScriptId === field2.scriptId
        );

        if (fieldReference1 && fieldReference2) {
            // Custom segments fields first
            if (
                fieldReference1.NetSuiteField.Field.ScriptId.startsWith('cseg') &&
                !fieldReference2.NetSuiteField.Field.ScriptId.startsWith('cseg')
            ) {
                return -1;
            }

            if (
                !fieldReference1.NetSuiteField.Field.ScriptId.startsWith('cseg') &&
                fieldReference2.NetSuiteField.Field.ScriptId.startsWith('cseg')
            ) {
                return 1;
            }

            return fieldReference1.NetSuiteField.Order - fieldReference2.NetSuiteField.Order;
        }

        return 0;
    });
};
